import { render } from "./LeasesList.vue?vue&type=template&id=aaeac334"
import script from "./LeasesList.vue?vue&type=script&lang=js"
export * from "./LeasesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__